<template>
    <vs-dialog
        v-model="alert.show"
        blur
        not-close
        Scroll
        overflow-hidden
        auto-width
        prevent-close>
        <template #header>
            <h6>{{ $t(title) }}</h6>
        </template>

        <slot name="custom-content"/>

        <template #footer>
            <slot name="custom-actions"/>
        </template>
    </vs-dialog>
</template>
<script>
    // HELPERS
    import _GlobalHelper from '@/store/helpers/global'
    // VUEX
    import { mapGetters } from 'vuex'

    export default {
        props: {
            title: {
                type: String,
                default: ''
            }
        },
        computed: {
        	...mapGetters({
				alert: _GlobalHelper.getters.alert_itinerary
			})
		}
    }
</script>
